import React, { Component, createElement } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import moment from 'moment'
import {} from 'moment-range'
import Button from 'shared-web/src/components/Button'
import LoadingDots from 'shared-web/src/components/Loading'
import { Map } from 'immutable'
import { makeDefaultFailedContainer } from 'components/container'
import { makeHasGate } from 'app/modules/gates/selectors'
import * as TimelineSelectors from 'app/modules/endUser/timeline/selectors'
import * as TimelineActions from 'app/modules/endUser/timeline/actions'
import Filters from './Filters'
import ConversationEvent from './ConversationEvent'
import EmailCaptureCampaignEvent from './EmailCaptureCampaignEvent'
import EndUserAddedEvent from './EndUserAddedEvent'
import MessageCampaignEvent from './MessageCampaignEvent'
import NoteLoggingEvent from './NoteLoggingEvent'
import NPSResponseEvent from './NPSResponseEvent'
import NPSCampaignEvent from './NPSCampaignEvent'
import TagEvent from './TagEvent'
import GenericEvent from './GenericEvent'
import PageViewEvent from './PageViewEvent'
import EndUserPropertyUpdateEvents from './EndUserPropertyUpdateEvents'
import colors from 'styles/colors.json'
import styles from './style.styl'

const eventToComponent = (event) => {
  switch (event.eventType) {
    case 'ADDED':
      return EndUserAddedEvent
    case 'NOTE':
      return NoteLoggingEvent
    case 'MESSAGE_SEEN':
    case 'MESSAGE_SENT':
    case 'MESSAGE_CTA_CLICKED':
      return MessageCampaignEvent
    case 'NPS_RESPONDED':
      return NPSResponseEvent
    case 'NPS_SENT':
      return NPSCampaignEvent
    case 'EMAIL_CAPTURE_SUBMITTED':
      return EmailCaptureCampaignEvent
    case 'CONVERSATION':
      return ConversationEvent
    case 'TAG_REMOVE':
    case 'TAG_ADD':
      return TagEvent
    case 'TRIGGERED_EVENT':
      if (event.body && event.body.event === 'page') {
        return PageViewEvent
      } else {
        return GenericEvent
      }
    case 'PROPERTY':
      return EndUserPropertyUpdateEvents
    default:
      return GenericEvent
  }
}

const NoActivityProps = {
  style: {
    marginLeft: 38
  },
  className: 'color-navy-dark dsg-Body'
}

const NoActivity = (
  <div {...NoActivityProps}>No activity</div>
)

const LoadMore = ({ onClick }) => {
  return (
    <div className="flex-center" style={{ margin: '10px 0' }}>
      <Button
        hollow
        onClick={onClick}
        role="secondary"
      >
        { onClick ? 'Load 20 More' : <LoadingDots color="#13DDB0" size="medium"/> }
      </Button>
    </div>
  )
}

function MonthDivider({ months }) {
  return (
    <div className={`${styles.MonthDivider} color-navy-dark dsg-Regular dsg-medium-weight`}>
      { months.length === 1 ? moment(months[0]).format(`MMMM YYYY`) : `${moment(months[0]).format(`MMMM YYYY`)} - ${moment(months[months.length - 1]).format(`MMMM YYYY`)}`}
    </div>
  )
}

class TimeLine extends Component {
  state = {
    loading: false,
  }

  componentWillMount() {
    this.props.actions.fetchEvents({ endUserId: this.props.endUser.id, filter: this.props.filter.keySeq().toJS() })
  }

  componentWillReceiveProps(nextProps) {
    if (!this.props.filter.equals(nextProps.filter)) {
      this.props.actions.fetchEvents({ endUserId: this.props.endUser.id, filter: nextProps.filter.keySeq().toJS() })
    }
  }

  componentWillUnmount() {
    this.props.actions.cancelEventFetch({ endUserId: this.props.endUser.id })
  }

  loadMore = () => {
    const { endUser, filter } = this.props
    this.props.actions.loadMoreEvents({ endUserId: endUser.id, filter: filter.keySeq().toJS() })
  }

  renderLoadMore() {
    const { isTimelineLoadingMore } = this.props

    return (<LoadMore onClick={ !isTimelineLoadingMore ? this.loadMore : false }/>)
  }

  renderEvents() {
    const { events, endUser, isTimelineLoading } = this.props

    if (isTimelineLoading) {
      return (
        <div className="loading-dots-container">
          <LoadingDots color={colors['color-navy-dark']} />
        </div>
      )
    }

    if (events.length === 0) {
      return (
        <div className="empty-container dsg-Body color-gray-dark">No matching events found</div>
      )
    }

    const range = moment.range(moment(events[events.length - 1].createdAt).startOf('month'), moment().startOf('month'))
    const months = []
    // Time range has no option to do this in descending order, this reverses it
    range.by('M', (month) => {
      months.unshift(month)
    })
    let currentIndex = 0
    const rows = []
    let emptyMonths
    months.forEach((month) => {
      if (!moment(events[currentIndex].createdAt).isSame(month, 'month')) {
        if (emptyMonths) {
          emptyMonths.push(month)
        } else {
          emptyMonths = [month]
        }
        return
      }
      if (emptyMonths) {
        rows.push(<MonthDivider months={emptyMonths}/>)
        rows.push(NoActivity)
        emptyMonths = false
      }
      rows.push(<MonthDivider months={[month]}/>)
      while (currentIndex < events.length && moment(events[currentIndex].createdAt).isSame(month, 'month')) {
        const event = events[currentIndex]
        const component = eventToComponent(event)
        if (component) {
          const eventNode = createElement(component, { event, endUser })
          rows.push(eventNode)
        }
        currentIndex++
      }
    })
    return rows
  }

  render(){
    return (
      <div>
        <div className={styles.TimeLine} style={{ marginTop: 10 }}>
          {this.renderEvents()}
        </div>
        { this.props.hasNext ? this.renderLoadMore() : null }
      </div>
    )
  }
}

function mapStateToProps(state) {
  return {
    hasReduxTimeline: true,
    events: TimelineSelectors.events(state).toJS(),
    isTimelineLoading: TimelineSelectors.isLoading(state),
    isTimelineLoadingMore: TimelineSelectors.isLoadingMore(state),
    hasNext: TimelineSelectors.hasNext(state),
  }
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({
      fetchEvents: TimelineActions.fetchTimelineEventsForEndUser,
      cancelEventFetch: TimelineActions.fetchTimelineEventsForEndUserCancelled,
      loadMoreEvents: TimelineActions.loadMoreTimelineEventsForEndUser,
    }, dispatch)
  }
}

const TimelineContainer = connect(mapStateToProps, mapDispatchToProps)(TimeLine)

class TimeLineWrapper extends Component {
  constructor(props) {
    super(props)
    this.state = { filter: Map() }
  }

  updateFilter = (filter) => {
    this.setState({ filter })
  }

  render() {
    return (
      <div>
        <Filters filter={this.state.filter} updateFilter={this.updateFilter}/>
        <TimelineContainer filter={this.state.filter} {...this.props}/>
      </div>
    )
  }
}



export default connect((state) => ({
  hasReduxTimeline: makeHasGate('has_redux_timeline')(state)
}))(TimeLineWrapper)



// WEBPACK FOOTER //
// ./src/scripts/components/customer/TimeLine/index.js